import React, {useEffect, useState} from "react";
import clsx from "clsx";
import axios from "axios";
import {FaCar, FaFile, FaMobileAlt, FaPhone} from "react-icons/fa";
import {FaMessage, FaVolumeHigh} from "react-icons/fa6";
import {Modal} from "../../../../components/modal/modal.jsx";
import {getAssetPath} from "../../../../utils/get-asset-path.js";

const svgCache = new Map();

const HelpSvg = ({name, className}) => {
    const [svg, setSvg] = useState("");

    useEffect(() => {
        let mounted = true;
        if (!svgCache.has(name)) {
            svgCache.set(name, axios.get(getAssetPath(`img/dispatch-dashboard-svg/${name}.svg`), {responseType: "text"})
                .then(({data}) => typeof data === "string" ? data : "")
                .catch(() => { svgCache.delete(name); return ""; }));
        }
        svgCache.get(name).then(content => { if (mounted) setSvg(content); });
        return () => { mounted = false; };
    }, [name]);

    return <span className={className} dangerouslySetInnerHTML={{__html: svg}}/>;
};

const Swatch = ({status, label}) => (
    <div className="mb-1 flex items-center gap-2">
        <span className={clsx("span-help-custom inline-block h-4 w-9 rounded", status)}/>
        {label}
    </div>
);

const Info = ({icon, children}) => (
    <div className="mb-1 flex items-center gap-2">
        <span className="flex w-5 items-center justify-center">{icon}</span>
        <span>{children}</span>
    </div>
);

const SectionTitle = ({children}) => (
    <div className="modal-text"><span className="text-[18px]">{children}</span></div>
);

const cellLeft = {textAlign: "left"};
const cellRight = {textAlign: "right"};

const AttendanceTab = () => (
    <div>
        <div className="attendance-cards-panel-help mb-2">
            <div className="panel-heading-card"><div style={{padding: "2px"}}/></div>
            <div className="panel-title-card">
                <div className="flex-card title-card-help">
                    <div style={{padding: "2px"}}><strong>Natureza do Atendimento</strong></div>
                    <div>Tempo decorrido</div>
                </div>
            </div>
            <div className="attendances-cards-body-help">
                <div className="flex-card">
                    <div style={{width: "60%", ...cellLeft}}>Endereço do Atendimento</div>
                    <div style={{width: "40%", ...cellRight}}><div className="code-card-priority">Prioridade</div></div>
                </div>
                <div className="flex-card"><div style={{width: "100%", ...cellLeft}}>Setor</div></div>
                <div className="flex-card">
                    <div style={{width: "60%", ...cellLeft}}>(<FaCar className="inline" style={{color: "#777"}}/> Tipo de veículo) Prefixo | Placa</div>
                    <div style={{width: "40%", ...cellRight}}><span className="font-number-card">Protocolo</span></div>
                </div>
            </div>
        </div>

        <hr className="separator-modal-help"/>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div>
                <SectionTitle>Situação</SectionTitle>
                <div className="mt-2">
                    <Swatch status="panic" label="Pânico"/>
                    <Swatch status="delayed" label="Atraso"/>
                    <Swatch status="onHold" label="Aberto"/>
                    <Swatch status="assignment" label="Atribuído"/>
                    <Swatch status="schedule" label="Agendado"/>
                    <Swatch status="inProgress" label="Em andamento"/>
                </div>
            </div>
            <div>
                <SectionTitle>Informações</SectionTitle>
                <div className="mt-2">
                    <Info icon={<FaPhone size={13}/>}>Atendimento recém criado pelo gravador de chamadas</Info>
                    <Info icon={<FaMessage size={13}/>}>Atendimento que possui chat</Info>
                    <Info icon={<FaMessage size={13} className="chat-notification"/>}>Mensagem de chat ainda não visualizada</Info>
                </div>
                <div className="mt-4">
                    <SectionTitle>Filtro de Chat</SectionTitle>
                    <div className="mt-2">
                        <Info icon={
                            <span className="relative inline-flex">
                                <FaMessage size={13}/>
                                <span className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-red-600"/>
                            </span>
                        }>Filtrar atendimentos com mensagens não lidas</Info>
                        <Info icon={<FaVolumeHigh size={14}/>}>Silenciar / reativar notificações sonoras do chat</Info>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

const TaskTab = () => (
    <div>
        <div className="task-cards-panel-help mb-2">
            <div className="panel-heading-card"><div style={{padding: "2px"}}/></div>
            <div className="panel-title-card">
                <div className="flex-card title-card-help">
                    <div style={{padding: "2px"}}><strong>Natureza da Tarefa</strong></div>
                </div>
            </div>
            <div className="task-cards-body-help">
                <div className="flex-card"><div style={{width: "100%", ...cellLeft}}>Origem - Identificação da Tarefa</div></div>
                <div className="flex-card"><div style={{width: "100%", ...cellLeft}}>Endereço da Tarefa</div></div>
            </div>
        </div>

        <hr className="separator-modal-help"/>

        <div>
            <SectionTitle>Situação</SectionTitle>
            <div className="mt-2">
                <Swatch status="onHold" label="Aberto"/>
                <Swatch status="assignment" label="Atribuído"/>
                <Swatch status="inProgress" label="Em andamento"/>
            </div>
        </div>
    </div>
);

const GarrisonTab = ({boName}) => (
    <div>
        <div className="flex flex-wrap justify-center gap-6">
            <div>
                <div className="modal-text text-center"><span className="text-[15px]">Disponível</span></div>
                <div className="garrison-cards-panel-help">
                    <div className="panel-heading-card"><div style={{padding: "2px 4px"}}/></div>
                    <div className="panel-title-card">
                        <div className="flex-card"><div className="title-card-help" style={{padding: "2px"}}>Função destinada</div></div>
                    </div>
                    <div className="garrisons-cards-body-help">
                        <div className="flex-card" style={{height: "24px"}}/>
                        <div className="flex-card"><div style={{width: "100%", ...cellLeft}}>Local (Posto fixo)</div></div>
                        <div className="flex-card">
                            <div style={{width: "50%", ...cellLeft}}>Setor</div>
                            <div style={{width: "50%", ...cellRight}}>Classe do Veículo</div>
                        </div>
                        <div className="flex-card">
                            <div style={{width: "50%", ...cellLeft}}>Contingente</div>
                            <div style={{width: "50%", ...cellRight}}>Equipe</div>
                        </div>
                        <div className="flex-card"><div style={{width: "100%", ...cellLeft}}>(<FaCar className="inline" style={{color: "#969696"}}/> Tipo de veículo) Prefixo | Placa</div></div>
                    </div>
                </div>
            </div>
            <div>
                <div className="modal-text text-center"><span className="text-[15px]">Despachado</span></div>
                <div className="garrison-cards-panel-help">
                    <div className="panel-heading-card"><div style={{padding: "2px 4px"}}/></div>
                    <div className="panel-title-card">
                        <div className="flex-card"><div className="title-card-help" style={{padding: "2px"}}>Natureza do Despacho</div></div>
                    </div>
                    <div className="garrisons-cards-body-help">
                        <div className="flex-card">
                            <div style={{width: "33%", ...cellLeft}}><span className="font-number-card">Nº Talão</span></div>
                            <div style={{width: "33%", textAlign: "center"}}><FaFile className="inline"/> <span className="font-number-card">Nº de {boName}</span></div>
                            <div style={{width: "33%", ...cellRight}}>Tempo decorrido</div>
                        </div>
                        <div className="flex-card"><div style={{width: "100%", ...cellLeft}}>Endereço do Despacho/Deslocamento</div></div>
                        <div className="flex-card">
                            <div style={{width: "50%", ...cellLeft}}>Setor</div>
                            <div style={{width: "50%", ...cellRight}}>Classe do Veículo</div>
                        </div>
                        <div className="flex-card">
                            <div style={{width: "50%", ...cellLeft}}>Contingente</div>
                            <div style={{width: "50%", ...cellRight}}>Equipe</div>
                        </div>
                        <div className="flex-card"><div style={{width: "100%", ...cellLeft}}>(<FaCar className="inline" style={{color: "#969696"}}/> Tipo de veículo) Prefixo | Placa <span className="span-card-custom-suport">+Apoios</span></div></div>
                    </div>
                </div>
                <div className="mt-1 text-[12px] text-[#555]">** A guarnição de apoio se encontra ao lado da guarnição apoiada</div>
            </div>
        </div>

        <hr className="separator-modal-help"/>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div>
                <SectionTitle>Situação</SectionTitle>
                <div className="mt-2">
                    <Swatch status="panic" label="Pânico"/>
                    <Swatch status="inProgress" label="Despachado"/>
                    <Swatch status="dispatchSupport" label="Apoio"/>
                    <Swatch status="dispatchActivity" label="Atividade"/>
                    <Swatch status="available" label="Disponível"/>
                </div>
            </div>
            <div>
                <SectionTitle>Informações</SectionTitle>
                <div className="mt-2">
                    <Info icon={<FaMobileAlt size={13}/>}>Guarnição com aplicativo</Info>
                    <Info icon={<HelpSvg name="phone-new" className="card-icon-phone-new"/>}>Guarnição recém criada pelo aplicativo</Info>
                    <Info icon={<HelpSvg name="phone-no-signal" className="card-icon-phone-nosignal"/>}>Guarnição com aplicativo sem sinal ou sem GPS</Info>
                    <Info icon={<span className="dispatch-source-icon-helper">C</span>}>Despachado via central</Info>
                    <Info icon={<span className="dispatch-source-icon-helper">A</span>}>Auto despacho pelo aplicativo</Info>
                    <Info icon={<span className="dispatch-source-icon-helper">R</span>}>Despachado pelo responsável</Info>
                    <Info icon={<HelpSvg name="sw-assignment" className="card-icon-assignment"/>}>Atribuído</Info>
                    <Info icon={<HelpSvg name="view" className="card-icon-view"/>}>Despacho enviado para o aplicativo</Info>
                    <Info icon={<HelpSvg name="viewer" className="card-icon-viewer"/>}>Despacho recebido no aplicativo</Info>
                    <Info icon={<HelpSvg name="viewer" className="card-icon-viewer icon-viewer-visualized"/>}>Despacho visualizado no aplicativo</Info>
                </div>
            </div>
        </div>
    </div>
);

const DashboardHelpModal = ({open, setOpen, permissions = {}, boName = "BO"}) => {
    const tabs = [
        permissions.attendance && {key: "attendance", label: "Atendimento"},
        permissions.task && {key: "task", label: "Tarefas"},
        permissions.garrison && {key: "garrison", label: "Guarnição"},
    ].filter(Boolean);

    const [active, setActive] = useState(tabs[0]?.key);

    useEffect(() => {
        if (open) setActive(tabs[0]?.key);
    }, [open]);

    return (
        <Modal open={open} setOpen={setOpen} title="Ajuda" className="w-full max-w-5xl">
            <Modal.Body className="max-h-[calc(100vh-180px)] overflow-auto">
                <ul className="mb-3 flex gap-1 border-b border-[#ddd]">
                    {tabs.map(tab => (
                        <li key={tab.key}>
                            <button
                                type="button"
                                onClick={() => setActive(tab.key)}
                                className={clsx(
                                    "-mb-px border-b-2 px-3 py-2 text-[13px] cursor-pointer",
                                    active === tab.key ? "border-[#063A6C] font-bold text-[#063A6C]" : "border-transparent text-[#777]",
                                )}
                            >
                                {tab.label}
                            </button>
                        </li>
                    ))}
                </ul>

                {active === "attendance" && <AttendanceTab/>}
                {active === "task" && <TaskTab/>}
                {active === "garrison" && <GarrisonTab boName={boName}/>}
            </Modal.Body>
        </Modal>
    );
};

export default DashboardHelpModal;
